var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"toolbar-btn js-md",attrs:{"type":"button","tabindex":"-1","data-container":"body","data-md-tag":_vm.tag,"data-md-block":_vm.tagBlock,"data-md-prepend":_vm.prepend,"title":_vm.buttonTitle,"aria-label":_vm.buttonTitle}},[_c('icon',{attrs:{"name":_vm.icon}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e885040","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar_button.vue
// module id = null
// module chunks = 